import { Modal } from "../../Components/Models/Modal";


class AuthModalModel extends Modal {
    private _isSignUp: boolean = false

    constructor(){
        super()
        this.visible = true
    }
    
    get isSignUp(){
        return this._isSignUp
    }

    showSignUpModal = () => {
        this._isSignUp = true
        this.show()
        setTimeout(()=>{
            this._isSignUp = false
        }, 100)
    }
}

export { AuthModalModel }